export default class Action {
  undo() {
    console.log('')
  }
  redo() {
    console.log('')
  }
}
